/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LogoService } from '../../services/logo.service';
import { UserService } from '../../services/user.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { tabOptions } from '../../configs/tab-options.config';

@Component({
  selector: 'app-power-bi-embed',
  templateUrl: './power-bi-embed.component.html',
  styleUrls: ['./power-bi-embed.component.scss'],
})
export class PowerBiEmbedComponent  implements OnInit {

    user: any = {};
    orgId: number | undefined;
    logoDetails: any;
    isLoading: boolean = true; 
    routeOption: string = '';
    tabTitle: SafeResourceUrl = '';
    tabOptions=tabOptions

    constructor(private userService:UserService,private ls:LogoService,private cdr:ChangeDetectorRef,private route: ActivatedRoute,private sanitizer: DomSanitizer) { }
  
    ngOnInit() {
      this.route.paramMap.subscribe(params => {
        this.routeOption = params.get('option')!;
        const tabConfig = this.tabOptions.find(tab => tab.route === '/' + this.routeOption);
        if (tabConfig) {
          this.tabTitle = tabConfig.label;
        } else {
          this.tabTitle = ''; // Optionally handle unknown routes
        }
      });
     
      this.user = this.userService.getUser();
      this.orgId = this.userService.getOrgId();
      this.logoDetails = this.ls.logoDetails ? this.ls.logoDetails : this.ls.getLogoPath(this.orgId);
    }
    onIframeLoad() {
  
      this.isLoading = false;
      this.cdr.detectChanges();
    }

}
